import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  CardTitle,
  Form,
  Row,
  Col,
  Label,
  Input,
  navigate,
  Toast,
  ToastHeader,
  ToastBody,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Link, useNavigate } from "react-router-dom"
import VLogo from "../../../assets/images/VIP/VLogo.png"
import { getUnitDetail } from "store/masters/project-unit/actions"
import { useDispatch, useSelector } from "react-redux"
import { createSelector } from "reselect"
import { update } from "lodash"
import { addNewUnit, updateUnit } from "helpers/fakebackend_helper"
import Swal from "sweetalert2"

const NewProjectUnit = () => {
  const [isEditMode, setIsEditMode] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [toast2, setToast2] = useState(false)

  const dispatch = useDispatch()
  const projectunitState = state => state.units.unitDetail.Data
  // const loadingState = state => state.facilities.loading
  const data = useSelector(projectunitState)

  const projectunitsProperties = createSelector(
    projectunitState,
    // loadingState,
    (projectunits, loading) => {
      return {
        projectunits: projectunits,
        loading: loading,
      }
    }
  )

  const { projectunits, loading } = useSelector(projectunitsProperties)

  const [specificUser, setSpecificUser] = useState(null)

  const [projectunitId, setprojectunitId] = useState()

  const projectunitData = () => {
    try {
      const url = new URL(window.location.href)
      if (url.href.includes("edit")) {
        setIsEditMode(true)
      }

      const projectunitId = url.pathname.split("/edit-project-unit/")[1]
      setprojectunitId(projectunitId)
      // const response =  dispatch(getCompanyDetail(facilityId))
      // if(isEditMode === true){
      const response = dispatch(getUnitDetail(projectunitId))
      // } else {
      //don't dispatch or reset form
      // setIsEditMode(false)
      // }

      // setLoading(false)
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    if (location.pathname.includes("edit")) {
      projectunitData()
    }
  }, [dispatch])
  const validation = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: isEditMode
      ? {
          category_title: (projectunits && projectunits.category_title) || "",
          // is_promotional_unit: false,
          is_promotional_unit:
            (projectunits && projectunits.is_promotional_unit) || false,
          is_active: (projectunits && projectunits.is_active) || false,
          // is_active: false,
        }
      : {
          category_title: "",
          is_promotional_unit: false,
          is_active: false,
        },
    validationSchema: Yup.object({
      category_title: Yup.string().required("Please Enter Category title"),
      is_promotional_unit: Yup.boolean(),
      // is_active: Yup.boolean().required("Please Select Valid Option"),
      is_active: Yup.boolean(),
    }),

    onSubmit: async values => {
      try {
        const loadingSwal = Swal.fire({
          title: "Loading...",
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })

        if (isEditMode === true) {
          const response = await updateUnit(projectunitId, values)

          if (response && response.status === true) {
            Swal.fire({
              title: "Success",
              icon: "success",
              text: "Your Project Unit Category has been updated.",
            }).then(result => {
              if (result.isConfirmed) {
                navigate("/settings/project-unit-service")
              }
            })
          } else {
            Swal.fire({
              title: "failure",
              icon: "error",
              text: "Your work has been saved.",
            })
          }
        } else if (isEditMode === false) {
          const response = await addNewUnit(values)
          if (response && response.status === true) {
            Swal.fire({
              title: "Success",
              icon: "success",
              text: "Your Project Unit Category has been created.",
            }).then(result => {
              if (result.isConfirmed) {
                navigate("/settings/project-unit-service")
              }
            })
          } else {
            Swal.fire({
              title: "failure",
              icon: "error",
              text: "Your Project Unit Category has not been saved.",
            })
          }
        }
      } catch (error) {
        console.error("Error:", error)
        Swal.fire({
          title: "Error",
          icon: "error",
          text:
            error.response.data.message ||
            "An error occurred while saving your work.",
        })
      }
    },

    // onSubmit: values => {
    //   dispatch(loginUser(values, props.router.navigate))
    // },
  })

  const navigate = useNavigate()
  const toggleToast = () => {
    setToast(!toast)
  }
  const toggleToast2 = () => {
    setToast2(!toast2)
  }

  function tog_center() {
    setmodal_center(!modal_center)
    removeBodyCss()
  }
  function tog_center2() {
    setmodal_center2(!modal_center2)
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab)
    }
  }
  useEffect(() => {
    // Check if the current path includes 'edit-project'
    if (location.pathname.includes("edit")) {
      setIsEditMode(true)
    } else {
      setIsEditMode(false)
    }
  }, [location.pathname])

  const handleSubmit = e => {
    e.preventDefault()
    setIsSubmitted(true)
    setToast2(true)
  }

  const [selectedOption, setSelectedOption] = useState(projectunits?.is_active)
  const [selectedOptionNew, setSelectedOptionNew] = useState(
    projectunits?.is_mandatory
  )

  const handleChange1 = () => {
    const newValue = !selectedOption
    setSelectedOption(newValue)
    validation.setFieldValue("is_active", newValue)
  }
  const handleChange2 = () => {
    const isPromotionalValue = !selectedOptionNew
    setSelectedOptionNew(isPromotionalValue)
    validation.setFieldValue("is_promotional_unit", isPromotionalValue)
  }
  return (
    <div className="page-content">
      <Row>
        <Col>
          <div className="d-flex gap-2 mb-3">
            <i
              className="mdi mdi-arrow-left font-size-20"
              style={{ color: "grey", marginRight: "15px" }}
              onClick={() => {
                navigate(-1)
              }}
            ></i>
            <span
              style={{ color: "black", fontWeight: "500", fontSize: "18px" }}
            >
              {" "}
              {isEditMode
                ? "Edit Project Unit Category"
                : "New Project Unit Category"}
            </span>
          </div>
        </Col>
        <Col>
          <Breadcrumbs title="Settings / Master configuration / Project Unit Category Master" />
        </Col>
      </Row>
      <div className="mt-3"></div>

      {/* <CardTitle className="mb-4">New Project Unit</CardTitle> */}
      <Card>
        <CardBody>
          <Form
            autoComplete="off"
            onSubmit={e => {
              e.preventDefault()
              validation.handleSubmit()
              return false
            }}
          >
            <Row>
              <Col>
                <div className="mb-3">
                  <Label htmlFor="formrow-newexpense-Input">
                    Category title*
                  </Label>
                  <Input
                    type="text"
                    name="category_title"
                    className="form-control"
                    id="formrow-newexpense-Input"
                    placeholder="Enter Category title"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.category_title || ""}
                    invalid={
                      validation.touched.category_title &&
                      validation.errors.category_title
                        ? true
                        : false
                    }
                  />
                  {validation.touched.category_title &&
                  validation.errors.category_title ? (
                    <FormFeedback type="invalid">
                      {validation.errors.category_title}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col>
                <div>
                  <div className="mb-3"></div>
                  <Label htmlFor="formrow-isdependent-Input">
                    Is Promotional unit
                  </Label>
                </div>

                <Col lg="12">
                  <div className="form-check form-check-inline">
                    <Input
                      type="checkbox"
                      // className="form-check-Input"
                      id="is-dependent"
                      name="is_promotional_unit"
                      onChange={e => {
                        validation.setFieldValue("is_promotional_unit", e.target.checked)
                      }}
                      checked={Boolean(validation?.values?.is_promotional_unit)}
                      onBlur={validation.handleBlur}
                      // value={validation.values.is_promotional_unit || false}
                      className={`form-check-Input ${
                        validation.touched.is_promotional_unit &&
                        validation.errors.is_promotional_unit
                          ? "is-invalid"
                          : ""
                      }`}
                    />
                    <Label
                      className="form-check-Label"
                      htmlFor="formrow-customCheck"
                    >
                      Yes
                    </Label>
                  </div>
                  {validation.touched.is_promotional_unit &&
                    validation.errors.is_promotional_unit && (
                      <FormFeedback type="invalid">
                        {validation.errors.is_promotional_unit}
                      </FormFeedback>
                    )}
                </Col>
              </Col>
            </Row>
            <Row>
              <Col>
                <div>
                  <div className="mb-3"></div>
                  <Label htmlFor="formrow-isactive-Input">Is Active</Label>
                </div>

                <Col lg="12">
                  <div className="form-check form-check-inline">
                    <Input
                      type="checkbox"
                      className="form-check-Input"
                      id="is_active"
                      name="is_active"
                      onChange={e => {
                        validation.setFieldValue("is_active", e.target.checked)
                      }}
                      checked={Boolean(validation?.values?.is_active)}
                    />
                    <Label
                      className="form-check-Label"
                      htmlFor="formrow-customCheck"
                    >
                      Yes
                    </Label>
                  </div>
                  {validation.touched.is_active &&
                    validation.errors.is_active && (
                      <FormFeedback type="invalid">
                        {validation.errors.is_active}
                      </FormFeedback>
                    )}
                </Col>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="mb-3 text-end">
                  <button type="submit" className="btn btn-primary w-md">
                    {isEditMode ? "Edit" : "Submit"}
                  </button>
                </div>
                {toast2 && (
                  <div
                    className="position-fixed top-0 end-0 p-3"
                    style={{ zIndex: "1005" }}
                  >
                    <Toast isOpen={toast2} role="aleart">
                      <ToastHeader toggle={() => setToast2(!toast2)}>
                        <img src={VLogo} alt="" className="me-2" height="18" />
                        <strong className="me-auto">VIP Mall</strong>
                      </ToastHeader>
                      <ToastBody>
                        {!isEditMode
                          ? "Submitted Successfully"
                          : "Edited Successfully"}
                      </ToastBody>
                    </Toast>
                  </div>
                )}
              </Col>
            </Row>
          </Form>
        </CardBody>
      </Card>
    </div>
  )
}

export default NewProjectUnit
